import type { PortableTextComponentProps } from '@portabletext/react';
import type { ImageWithMetadata} from '../components/SanityImage';
import SanityImage, { imageWithMetadataGroq } from '../components/SanityImage';
import useDataAttribute from '../infrastructure/DataAttributeContext';
import * as style from './richText.module.css';

export const linkCardGroq = /* groq */ `
{
    reference -> {
        _id,
        _type,
        title,
        bannerImage ${imageWithMetadataGroq},
    },
    linkText,
    kicker,
    showImage
}
`;

const LinkCardImageSizes = [150, 150 * 2, 150 * 3];

interface LinkCardValue {
    _key: string;
    reference?: {
        path: string;
        title: string;
        bannerImage: ImageWithMetadata;
    };
    kicker?: string;
    linkText?: string;
    showImage?: boolean;
}

export function LinkCard({ value }: PortableTextComponentProps<LinkCardValue>) {
    const attr = useDataAttribute();
    return (
        <a className={style.linkCard} href={value?.reference?.path} data-sanity={attr?.([{ _key: value._key }])} role="complementary">
            <h2>
                <span>{value.kicker}</span>
                {value.linkText || value.reference?.title}
            </h2>
            {value.showImage && (
                <SanityImage image={value.reference?.bannerImage} sizes="150px" widths={LinkCardImageSizes} aspectRatio={16 / 9} lazy />
            )}
        </a>
    );
}
